import { render, staticRenderFns } from "./qc_notice.vue?vue&type=template&id=27055814&scoped=true&"
import script from "./qc_notice.vue?vue&type=script&lang=js&"
export * from "./qc_notice.vue?vue&type=script&lang=js&"
import style0 from "./qc_notice.vue?vue&type=style&index=0&id=27055814&scoped=true&lang=less&"
import style1 from "./qc_notice.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27055814",
  null
  
)

export default component.exports